exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".numberCircle[data-v-1a794db3]{position:absolute;top:8px;left:8px;line-height:0;display:inline-block;border-radius:50%;border:1px solid;font-size:10px;color:#fff;background-color:rgba(202,224,42,.7);z-index:10}.numberCircle span[data-v-1a794db3]{display:inline-block;padding-top:50%;padding-bottom:50%;margin-left:8px;margin-right:8px}.router-link-exact-active[data-v-1a794db3]{font-weight:600;background-color:#2874a6;border:1px solid #2874a6}", ""]);

// exports
